import React from "react";

const moodStyles = {
  great: { color: "#22c55e", mouth: "M8 13c2 3 6 3 8 0", eyes: "happy" },
  good: { color: "#34d399", mouth: "M9 14c2 2 4 2 6 0", eyes: "happy" },
  normal: { color: "#60a5fa", mouth: "M9 15h6", eyes: "normal" },
  sensitive: { color: "#a78bfa", mouth: "M9 16c2-2 4-2 6 0", eyes: "normal", tear: true },
  sad: { color: "#818cf8", mouth: "M8 16c2-3 6-3 8 0", eyes: "normal" },
  tense: { color: "#fb923c", mouth: "M8.5 15h7", eyes: "tense" },
  anxious: { color: "#f472b6", mouth: "M10 16c1-1 3-1 4 0", eyes: "normal", tear: true },
};

export function MoodIcon({ mood = "normal", size = 30, className = "" }) {
  const style = moodStyles[mood] || moodStyles.normal;
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="12" cy="12" r="10" fill={style.color} fillOpacity=".16" stroke={style.color} strokeWidth="1.7" />
      {style.eyes === "happy" ? (
        <><path d="M7.5 10c.7-1.2 2.3-1.2 3 0" stroke={style.color} strokeWidth="1.7" strokeLinecap="round" /><path d="M13.5 10c.7-1.2 2.3-1.2 3 0" stroke={style.color} strokeWidth="1.7" strokeLinecap="round" /></>
      ) : style.eyes === "tense" ? (
        <><path d="m7.5 9.5 3 1M16.5 9.5l-3 1" stroke={style.color} strokeWidth="1.7" strokeLinecap="round" /></>
      ) : (
        <><circle cx="9" cy="10" r="1" fill={style.color} /><circle cx="15" cy="10" r="1" fill={style.color} /></>
      )}
      <path d={style.mouth} stroke={style.color} strokeWidth="1.7" strokeLinecap="round" />
      {style.tear && <path d="M17.2 11.8c1.3 1.7 1.3 2.7 0 3.1-1.3-.4-1.3-1.4 0-3.1Z" fill="#38bdf8" />}
    </svg>
  );
}

export function CycleGlyph({ name, size = 24, className = "" }) {
  const paths = {
    drop: <path d="M12 3s6 6.4 6 11a6 6 0 1 1-12 0c0-4.6 6-11 6-11Z" />,
    calendar: <><rect x="3" y="5" width="18" height="16" rx="3" /><path d="M7 3v4M17 3v4M3 10h18M8 14h.01M12 14h.01M16 14h.01M8 18h.01M12 18h.01" /></>,
    spark: <path d="m12 3 1.5 5.5L19 10l-5.5 1.5L12 17l-1.5-5.5L5 10l5.5-1.5L12 3Zm6 13 .7 2.3L21 19l-2.3.7L18 22l-.7-2.3L15 19l2.3-.7L18 16Z" />,
    note: <><path d="M6 3h9l3 3v15H6z" /><path d="M14 3v4h4M9 12h6M9 16h5" /></>,
    shield: <path d="M12 3 5 6v5c0 4.6 2.8 8 7 10 4.2-2 7-5.4 7-10V6l-7-3Zm-3 9 2 2 4-4" />,
    settings: <><circle cx="12" cy="12" r="3" /><path d="M19 12a7 7 0 0 0-.1-1l2-1.5-2-3.4-2.4 1a8 8 0 0 0-1.7-1L14.5 3h-5l-.4 3.1a8 8 0 0 0-1.7 1l-2.4-1-2 3.4L5.1 11a7 7 0 0 0 0 2L3 14.5 5 18l2.4-1a8 8 0 0 0 1.7 1l.4 3h5l.4-3a8 8 0 0 0 1.7-1l2.4 1 2-3.5-2.1-1.5c.1-.3.1-.7.1-1Z" /></>,
    chart: <><path d="M4 19V5M4 19h16" /><path d="m7 15 3-4 3 2 5-7" /><circle cx="7" cy="15" r=".8" fill="currentColor" stroke="none" /><circle cx="10" cy="11" r=".8" fill="currentColor" stroke="none" /><circle cx="13" cy="13" r=".8" fill="currentColor" stroke="none" /><circle cx="18" cy="6" r=".8" fill="currentColor" stroke="none" /></>,
    heart: <path d="M20.8 5.8a5.4 5.4 0 0 0-7.6 0L12 7l-1.2-1.2a5.4 5.4 0 1 0-7.6 7.6L12 22l8.8-8.6a5.4 5.4 0 0 0 0-7.6Z" />,
    activity: <path d="M3 12h4l2-6 4 12 2-6h6" />,
    symptom: <><path d="M12 3v4M12 17v4M3 12h4M17 12h4" /><circle cx="12" cy="12" r="4" /></>,
    check: <path d="m5 12 4 4L19 6" />,
  };
  return <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{paths[name] || paths.spark}</svg>;
}
